import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import React, { useEffect, useLayoutEffect } from "react";
import logo from "./logo.svg";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Route, Switch, BrowserRouter as Router, useLocation } from "react-router-dom";
import Home from "./containers/Home";
import ToastComponent from "./containers/Common/ToastComponent";
import ModalComponent from "./containers/Common/ModalComponent";
import Loader from "./components/Loader";
import ScrollToTop from "./ScrollToTop";
import { bindActionCreators } from "redux";
import { useDispatch } from "react-redux";

function App() {

  return (
    <div className="App">
      <ToastComponent />
      <Loader />
      <ModalComponent />
      <Router>
        <ScrollToTop>
          <Switch>
            <Route path="/" component={Home} />
            {/* <Route path="/dashboard" exact component={Home} /> */}
          </Switch>
        </ScrollToTop>
      </Router>
    </div>
  );
}

export default App;
